import { Button, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";

const UserModal = ({ visible, onCancel, onSubmit, initialValues }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      setLoading(false);
      form.resetFields(); // Reset form fields when the modal is opened
      form.setFieldsValue(initialValues || { user_type: 2 }); // Set initial values or default to user_type = 2
    }
  }, [visible, form, initialValues]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        onSubmit(values);
        // setTimeout(() => {
        //   setLoading(false);
        //   form.resetFields();
        //   onCancel();
        // }, 2000); // Simulate API call
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  return (
    <Modal
      visible={visible}
      title={initialValues ? "Edit New Account" : "Create New Account"}
      onCancel={onCancel}
      centered
      footer={[
        <>
          <button type="button" className="btn btn-light fs-7 fw-bold" key="back" onClick={onCancel}>Close</button>
          <button type="button" className="btn btn-danger fs-7 fw-bold ms-3" loading={loading} onClick={handleOk}> {initialValues ? "Update" : "Submit"}</button>
        </>
      ]}
    >
      <Form form={form} layout="vertical" name="userForm">
        <Form.Item
          name="name"
          label="Seller Account Name"
          className="form-check-label text-dark fw-bold"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Enter Seller Account Name" className="form-control form-control-solid"/>
        </Form.Item>
        {initialValues && (
          <Form.Item
            name="contact_no"
            label="Contact No"
            className="form-check-label text-dark fw-bold mb-0"
            rules={[
              { required: true, message: "Please input your contact number!" },
              { pattern: /^[0-9]{10}$/, message: "Contact number must be exactly 10 digits!" },
            ]}
       
          >
            <Input placeholder="Enter your contact number" className="form-control form-control-solid"/>
          </Form.Item>
        )}
       
      </Form>
    </Modal>
  );
};

export default UserModal;
